module.exports = __webpack_public_path__ + "img/user.b798c273.png";